import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useMusic } from './MusicContext';

function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const [menuOpen, setMenuOpen] = useState(false);
  const { hasEntered } = useMusic();

  const colorMap = {
    '/movie': 'text-white',
    '/art': 'text-white',
    '/team': 'text-[#3D2B1D]',
    '/storybook': 'text-[#3D2B1D]',
  };

  const navColor = colorMap[location.pathname] || 'text-[#3D2B1D]';
  const isLightPage =
    location.pathname === '/movie' || location.pathname === '/art';

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  const handleReturnHome = () => {
    setMenuOpen(false);
    navigate('/');
  };

  return (
    <>
      {/* Hamburger menu */}
      {ReactDOM.createPortal(
        <>
          {(!isHomePage || hasEntered) && <button
            className='md:hidden fixed top-[15px] right-[20px] z-[999999] bg-transparent border-none cursor-pointer p-2 flex flex-row items-center gap-2'
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label='Toggle menu'
          >
            {!menuOpen && (
              <span className={`text-[20px] font-bold uppercase tracking-wider ${isLightPage ? 'text-[#F7EDDE]' : 'text-[#3D2B1D]'}`}>Menu</span>
            )}
            <div className='flex flex-col gap-[6px]'>
              <span className={`block w-[28px] h-[3px] transition-all duration-300 ${menuOpen ? 'bg-[#3D2B1D] rotate-45 translate-y-[9px]' : isLightPage ? 'bg-[#F7EDDE]' : 'bg-[#3D2B1D]'}`}></span>
              <span className={`block w-[28px] h-[3px] transition-all duration-300 ${menuOpen ? 'bg-[#3D2B1D] opacity-0' : isLightPage ? 'bg-[#F7EDDE]' : 'bg-[#3D2B1D]'}`}></span>
              <span className={`block w-[28px] h-[3px] transition-all duration-300 ${menuOpen ? 'bg-[#3D2B1D] -rotate-45 -translate-y-[9px]' : isLightPage ? 'bg-[#F7EDDE]' : 'bg-[#3D2B1D]'}`}></span>
            </div>
          </button>}

          {menuOpen && (
            <div
              className='md:hidden fixed inset-0 z-[99999] flex flex-col items-center bg-cover bg-center bg-[#C4956C]'
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/hamburger.webp)`,
              }}
            >
              <div className='flex-1 flex flex-col items-center justify-center gap-2 -mt-[100px]'>
                <NavLink
                  to='/movie'
                  onClick={handleNavClick}
                  className='text-[#3D2B1D] text-[27px] uppercase font-bold no-underline'
                >
                  the movie
                </NavLink>
                <NavLink
                  to='/art'
                  onClick={handleNavClick}
                  className='text-[#3D2B1D] text-[27px] uppercase font-bold no-underline'
                >
                  the art
                </NavLink>
                <NavLink
                  to='/team'
                  onClick={handleNavClick}
                  className='text-[#3D2B1D] text-[27px] uppercase font-bold no-underline'
                >
                  the artists
                </NavLink>
                <NavLink
                  to='/storybook'
                  onClick={handleNavClick}
                  className='text-[#3D2B1D] text-[27px] uppercase font-bold no-underline'
                >
                  the storybook
                </NavLink>
              </div>
              <div
                className='flex flex-col items-center cursor-pointer hover:opacity-70 mb-[30px]'
                onClick={handleReturnHome}
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    '/Icon - Hand - LandingPage - F7EDDE.svg'
                  }
                  alt='Return Home'
                  className='w-[40px] h-[40px] object-contain mb-2'
                  style={{
                    filter:
                      'brightness(0) saturate(100%) invert(95%) sepia(10%) saturate(400%) hue-rotate(340deg) brightness(100%) contrast(90%)',
                  }}
                />
                <p className='text-[16px] text-[#F7EDDE] uppercase font-antelope-bold-caps'>
                  CLICK TO RETURN HOME
                </p>
              </div>
            </div>
          )}
        </>,
        document.body
      )}

    <nav className='relative w-full max-w-full bg-transparent z-[1000] pt-[15px] pb-[100px] md:pb-[100px]'>
      {/* Desktop nav links - hidden on mobile */}
      <div className='hidden md:flex items-center justify-between gap-5 px-[50px]'>
        <NavLink
          to='/movie'
          className={({ isActive }) =>
            `${navColor} text-[22px] uppercase font-bold relative ${
              isHomePage
                ? 'no-underline opacity-100'
                : isActive
                  ? 'underline opacity-100'
                  : 'no-underline opacity-50'
            }`
          }
        >
          the movie
        </NavLink>

        <NavLink
          to='/art'
          className={({ isActive }) =>
            `${navColor} text-[22px] uppercase font-bold relative ${
              isHomePage
                ? 'no-underline opacity-100'
                : isActive
                  ? 'underline opacity-100'
                  : 'no-underline opacity-50'
            }`
          }
        >
          the art
        </NavLink>

        <NavLink
          to='/team'
          className={({ isActive }) =>
            `${navColor} text-[22px] uppercase font-bold relative ${
              isHomePage
                ? 'no-underline opacity-100'
                : isActive
                  ? 'underline opacity-100'
                  : 'no-underline opacity-50'
            }`
          }
        >
          the artists
        </NavLink>

        <NavLink
          to='/storybook'
          className={({ isActive }) =>
            `${navColor} text-[22px] uppercase font-bold relative ${
              isHomePage
                ? 'no-underline opacity-100'
                : isActive
                  ? 'underline opacity-100'
                  : 'no-underline opacity-50'
            }`
          }
        >
          the storybook
        </NavLink>
      </div>
    </nav>
    </>
  );
}

export default Navigation;
